import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dates } from '../../util/dates';

@Component({
  selector: 'ngx-month-picker',
  template: `
    <div class="d-flex justify-content-between align-items-center">
      <nb-select [(ngModel)]="selectedFromMonth" size="small">
        <nb-option *ngFor="let month of months" [value]="month.value">
          {{ month.viewValue }}
        </nb-option>
      </nb-select>
      <nb-select class="pl-2" [(ngModel)]="selectedFromYear" size="small">
        <nb-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </nb-option>
      </nb-select>
      <div *ngIf='isRangeSelect' class="pl-2">~</div>
      <nb-select *ngIf='isRangeSelect' class="pl-2" [(ngModel)]="selectedToMonth" size="small">
        <nb-option *ngFor="let month of months" [value]="month.value">
          {{ month.viewValue }}
        </nb-option>
      </nb-select>
      <nb-select *ngIf='isRangeSelect' class="pl-2" [(ngModel)]="selectedToYear" size="small">
        <nb-option *ngFor="let year of years" [value]="year">
          {{ year }}
        </nb-option>
      </nb-select>
      <button nbButton ghost status="primary" class="ml-2" size="small" (click)="onDateChange()">
        <nb-icon icon="search-outline"></nb-icon>
      </button>
    </div>
  `,
})
export class MonthPickerComponent {
  @Input('isRangeSelect') public isRangeSelect: boolean = false;
  @Output() dateChange = new EventEmitter<any>();

  months = [
    { value: '01', viewValue: '1 월' },
    { value: '02', viewValue: '2 월' },
    { value: '03', viewValue: '3 월' },
    { value: '04', viewValue: '4 월' },
    { value: '05', viewValue: '5 월' },
    { value: '06', viewValue: '6 월' },
    { value: '07', viewValue: '7 월' },
    { value: '08', viewValue: '8 월' },
    { value: '09', viewValue: '9 월' },
    { value: '10', viewValue: '10 월' },
    { value: '11', viewValue: '11 월' },
    { value: '12', viewValue: '12 월' },
  ];

  years = [];
  selectedFromMonth: string;
  selectedFromYear: number;

  selectedToMonth: string;
  selectedToYear: number;

  constructor() {
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 10; i <= currentYear + 10; i++) {
      this.years.push(i);
    }
    const initStartDate = Dates.dateAddByUnit(new Date(), -12, "month", true);

    this.selectedFromMonth = ('0' + (initStartDate.getMonth() + 1)).slice(-2);
    this.selectedFromYear = initStartDate.getFullYear();
    this.selectedToMonth = ('0' + (new Date().getMonth() + 1)).slice(-2);
    this.selectedToYear = currentYear;
  }

  onDateChange() {
    const selecteFromdDate = new Date(this.selectedFromYear, parseInt(this.selectedFromMonth, 10) - 1, 1);
    const selectedToDate = new Date(this.selectedToYear, parseInt(this.selectedToMonth, 10) - 1, 1);
    this.dateChange.emit({from: selecteFromdDate, to: selectedToDate});
  }
}
